// removed by extract-text-webpack-plugin
module.exports = {"Example_Container":"Example__Example_Container__emDSe","Example_IMG":"Example__Example_IMG__vTNpp","Example_Main":"Example__Example_Main__w5dJO"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Example/Example.css
// module id = 94
// module chunks = 0